import { render, staticRenderFns } from "./BAEventsAdminDashboard.vue?vue&type=template&id=63336b32&scoped=true&"
import script from "./BAEventsAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./BAEventsAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63336b32",
  null
  
)

export default component.exports